import { registerMutation, useMutation } from 'data-fetching-client';
import { GET_USER_SETTINGS, GetUserSettingsQuery } from './useUserSetting';
import { UserAttributesClient } from 'frontend-preferences-client';
import Raven from 'raven-js';
const MUTATION = registerMutation({
  fieldName: GET_USER_SETTINGS,
  fetcher: variables => {
    return UserAttributesClient.forCaller('crm-object-board').write(variables.key, variables.value.toString()).catch(e => {
      Raven.captureException(new Error('Error setting user setting', {
        cause: e
      }), {
        extra: {
          variables
        }
      });
      return variables.value.toString();
    });
  }
});
export const useSetUserSetting = () => {
  const [setUserSettingMutation] = useMutation(MUTATION, {
    optimisticResponse(variables) {
      return {
        [GET_USER_SETTINGS]: variables.value.toString()
      };
    },
    update(cache, __result, {
      variables
    }) {
      if (!variables) {
        return;
      }
      const existing = cache.readQuery({
        query: GetUserSettingsQuery
      });
      cache.writeQuery({
        query: GetUserSettingsQuery,
        data: {
          [GET_USER_SETTINGS]: Object.assign({}, existing, {
            [variables.key]: variables.value.toString()
          })
        }
      });
    }
  });
  return setUserSettingMutation;
};